import { Progress } from "@/components/ui/progress";
import type { UploadItem } from "@/lib/r2Upload";

interface UploadProgressProps {
  items: ReadonlyArray<UploadItem>;
}

const UploadProgress = ({ items }: UploadProgressProps) => {
  if (items.length === 0) return null;

  const totalBytes = items.reduce((s, i) => s + i.size, 0);
  const uploadedBytes = items.reduce(
    (s, i) => s + (i.status === "success" ? i.size : i.bytesUploaded),
    0
  );
  const completed = items.filter((i) => i.status === "success").length;
  const failed = items.filter((i) => i.status === "failed").length;
  const inProgress = items.filter((i) => i.status === "uploading").length;

  const percent = totalBytes > 0 ? Math.round((uploadedBytes / totalBytes) * 100) : 0;

  return (
    <div className="space-y-3">
      <Progress value={percent} className="h-2" />
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">
          {completed} of {items.length} photos uploaded
          {inProgress > 0 && ` • ${inProgress} in flight`}
          {failed > 0 && (
            <span className="text-destructive"> • {failed} failed</span>
          )}
        </span>
        <span className="font-mono text-muted-foreground">{percent}%</span>
      </div>
    </div>
  );
};

export default UploadProgress;
